import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PageChanger from "../../Helpers/Components/Pagination"
import Handler from "../../Helpers/Components/Handler"
import TablePlaceHolder from "../../Helpers/Components/TablePlaceHolder"
import { DropdownToggle, DropdownButton } from '../../Helpers/Components/Dropdown';
import { toast } from "react-toastify";
import { getCookie } from "../../Helpers/Utils";
import Modal from "../../Helpers/Components/Modal";
import Select from 'react-select'

const List = () => {
    const { pageNo } = useParams()
    const navigate = useNavigate()
    const [next, setNext] = useState(false)
    const [loading, setLoading] = useState(false)
    const [carDetails, setCarDetails] = useState([])
    const person = getCookie('person')
    const [modal, setModal] = useState(false)
    const [reason, setReason] = useState({ reason: "", id: "" })
    const handleKeyDown = (event) => { if (event.key === "Enter") { event.preventDefault(); handleSearch(); } };
    const setPageNo = (value) => navigate(`/car/${value}`)
    const [search, setSearch] = useState("");
    const [appliedSearch, setAppliedSearch] = useState("");
    const sort = (sortBy, sort) => setFilter((prev) => ({ ...prev, sortBy: sortBy, sort: sort }))
    const [filter, setFilter] = useState({
        count: 10,
        sortBy: "carId",
        sort: false,
        search: "",
        status: "All",
        removed: "All"
    })
    const handleChange = (e) => {
        setPageNo(1)
        setFilter((prev) => ({ ...prev, [e.target.name]: e.target.value }))
    }
    const getCarDetails = async () => {
        setLoading(true)
        const response = await Handler({
            method: "post", url: `/car/search/${pageNo}?count=${filter?.count || 10}`,
            data: {
                ...(appliedSearch ? { searchValue: appliedSearch } : {}),
                ...(filter?.status !== "All" ? { status: filter?.status } : {}),
                ...(filter?.removed !== "All" ? { removed: filter?.removed } : {}),
                sort: filter?.sort,
                sortBy: filter?.sortBy
            }
        })
        if (response?.success) {
            setCarDetails(response?.data?.current)
            setNext(response?.data?.next)
        } else {
            setCarDetails([])
            setNext(false)
        }
        setLoading(false)
    }
    const setFilteration = (name, value) => {
        setPageNo(1)
        setFilter((prev) => ({ ...prev, [name]: value }))
    }
    const handleRemove = async () => {
        if (!reason?.reason) {
            return toast.error("Reason is required")
        }
        setLoading(true)
        const response = await Handler({ method: "patch", url: `/car/deactive/${reason?.id}`, data: { reason: reason.reason } })
        if (response?.success) {
            toast.success(response?.message)
            setModal(false)
            getCarDetails()
        } else {
            toast.error(response?.message)
        }
        setLoading(false)
    }
    const handleStatus = async (id, status) => {
        if (!status && !reason?.reason) {
            return toast.error("Reason is required")
        }
        setLoading(true)
        const response = await Handler({ method: "patch", url: `/car/status/${id}?status=${status}`, data: { ...(status ? {} : { reason: reason.reason }) } })
        if (response?.success) {
            toast.success(response?.message)
            setModal(false)
            getCarDetails()
        } else {
            toast.error(response?.message)
        }
        setLoading(false)
    }
    const handleSearch = () => {
        setPageNo(1);
        setAppliedSearch(search);
    };
    useEffect(() => {
        getCarDetails()
    }, [pageNo, filter, appliedSearch])
    return (
        <React.Fragment>
            <h5 className="text-center text-theme fs-4">Car List</h5>
            <div className="layout-card mt-4">
                <div className="row justify-content-between align-items-center">
                    <div className="col-lg-4">
                        <div className="d-flex align-items-center gap-2">
                            <div className="input-group">
                                <input type="text" className="form-control search-input" onKeyDown={handleKeyDown} autoComplete="off" placeholder="Search..." value={search} onChange={(e) => { if (e.target.value) setSearch(e.target.value); else { setSearch(""); setAppliedSearch(""); setPageNo(1); } }} name="search" />
                                <span className="input-group-text cancel-icon">{search && (<i className="fa-solid fa-circle-xmark cursor-pointer text-theme" onClick={() => { setSearch(""); setAppliedSearch(""); setPageNo(1); }} />)}</span>
                            </div>
                            <button className="btn btn-sm btn-theme" onClick={handleSearch}>Search</button>
                        </div>
                    </div>
                    <div className="col-lg-4 text-end">
                        <button className="btn btn-outline-success me-2" onClick={() => navigate(`/car/availability`)}><i className="fa-regular fa-calendar me-1"></i>Car Availability</button>
                        {
                            person === "admin" ?
                                <button className="btn-theme btn" onClick={() => navigate(`/car/register`)}>Register</button>
                                : ""
                        }
                    </div>
                </div>
                <div className='overflow list-table mt-3'>
                    <table className="table-bg table" borderless="true">
                        <thead>
                            <tr className="border-bottom" >
                                <th><div className='sort-head'><div className='sort-arrow' ><i className={filter?.sortBy === "carId" && filter?.sort === false ? "i-active" : ""} onClick={() => sort("carId", false)} >▲</i><i className={filter?.sortBy === "carId" && filter?.sort === true ? "i-active" : ""} onClick={() => sort("carId", true)} >▼</i></div> Car Id</div></th>
                                <th> Model</th>
                                <th>Colour</th>
                                <th> Reg No </th>
                                <th> Fastag Bank </th>
                                <th>Segment</th>
                                <th className="text-center">
                                    <DropdownToggle label={
                                        <> Status <i className="fa-solid fa-caret-down"></i> </>}>
                                        <DropdownButton label="All" className={`${filter?.status === "All" ? "active-option" : ""}`} onClick={() => { setFilteration("status", "All") }} />
                                        <DropdownButton label="Active" className={`${filter?.status === true ? "active-option" : ""}`} onClick={() => { setFilteration("status", true) }} />
                                        <DropdownButton label="Deactive" className={`${filter?.status === false ? "active-option" : ""}`} onClick={() => { setFilteration("status", false) }} />
                                    </DropdownToggle>
                                </th>
                                <th className="text-center">
                                    <DropdownToggle label={
                                        <> Available <i className="fa-solid fa-caret-down"></i> </>}>
                                        <DropdownButton label="All" className={`${filter?.removed === "All" ? "active-option" : ""}`} onClick={() => { setFilteration("removed", "All") }} />
                                        <DropdownButton label="Available" className={`${filter?.removed === false ? "active-option" : ""}`} onClick={() => { setFilteration("removed", false) }} />
                                        <DropdownButton label="Removed" className={`${filter?.removed === true ? "active-option" : ""}`} onClick={() => { setFilteration("removed", true) }} />
                                    </DropdownToggle>
                                </th>
                                <th className="text-center">Bookings</th>
                                {
                                    person === "admin" ? <th className="text-center">Action</th> : ""
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {!loading ?
                                (carDetails && carDetails?.length !== 0 ? carDetails?.map((value, key) => {
                                    return (
                                        <tr key={key} className={`table-content-row ${!value?.status ? "text-red" : ""}`}>
                                            <td><a className="" href={`/car/view/${value?.id}`}>{value?.carId || ""}</a></td>
                                            <td className="text-capitalize">{(value?.model || "")}</td>
                                            <td className="text-capitalize">{value?.color || ""}</td>
                                            <td>{value?.registrationNo || "-"}</td>
                                            <td>{value?.fasTagType || "-"}</td>
                                            <td>{value?.segment || "-"}</td>
                                            <td className="text-center">{person === "admin" && !value?.removed ? (<button className={`btn btn-sm ${!value?.status ? "btn-success" : "btn-danger"}`} onClick={() => { if (value?.status) { setReason({ id: value?.id }); setModal(true) } else handleStatus(value?.id, !value?.status) }}>{!value?.status ? "Activate" : "Deactivate"}</button>) : (value?.status ? "Active" : "Deactive")}</td>
                                            <td className="text-center">{person === "admin" && !value?.removed ?
                                                (<button className={`btn btn-sm ${!value?.removed ? "btn-success" : "btn-danger"}`} onClick={() => { setReason({ id: value?.id, removed: true }); setModal(true) }}>{value?.removed ? "Removed" : "Available"}</button>)
                                                : (value?.removed ? "Removed" : "Available")}</td>
                                            <th className="text-center"><i className="fa-solid fa-calendar cursor-pointer" onClick={() => navigate(`/car/events/${value?.id}`)}></i></th>
                                            <td className="text-center">{person === "admin" && !value?.removed ? <i className="fa-solid fa-pen-to-square cursor-pointer" onClick={() => navigate(`/car/update/${value?.id}`)}></i> : "-"}</td>
                                        </tr>
                                    )
                                }) :
                                    <tr className='text-center' ><td colSpan={person === "admin" ? 10 : 9}>No Data Found</td></tr>)
                                : <TablePlaceHolder count={person === "admin" ? 10 : 9} />
                            }
                        </tbody>
                    </table>
                </div>
                <div className="d-flex align-items-center justify-content-end mt-3">
                    <span className="me-2 fw-medium"> Page Count:  </span>
                    <Select
                        className="inside-select"
                        isDisabled={loading}
                        onChange={(selectedoption) => {
                            setFilteration("count", Number(selectedoption?.value))
                        }}
                        styles={{
                            control: (base, state) => ({
                                ...base,
                                borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                "&:hover": {
                                    borderColor: "#f16436"
                                }
                            }),
                            option: (style, state) => ({
                                ...style,
                                backgroundColor: state.isSelected
                                    ? "#f16436"
                                    : (state.isFocused || state.isActive)
                                        ? "#f164361a"
                                        : "white",
                                color: state.isSelected ? "white" : "black"
                            })
                        }}
                        value={filter?.count ? { label: filter?.count, value: filter?.count } : { label: 10, value: 10 }}
                        options={[
                            { label: 10, value: 10 },
                            { label: 20, value: 20 },
                            { label: 30, value: 30 },
                            { label: 40, value: 40 },
                            { label: 50, value: 50 },
                        ]}
                        placeholder="PageNo"
                    />
                </div>
                <PageChanger previousValue={Number(pageNo) > 1} nextValue={next} current={Number(pageNo)} onPageChange={setPageNo} pageValue='car' />
            </div>


            <Modal header="Reason" onShow={modal} toggle={() => setModal(false)} overlayToggle={() => setModal(false)} >
                <div className="modalPhoto">
                    <input autoComplete="off" value={reason?.reason || ""} placeholder="Reason" disabled={loading} className="form-control input-theme text-uppercase" type="text" onChange={(e) => setReason((prev) => ({ ...prev, reason: e.target.value }))} />
                </div>
                <div className="pt-4 pb-2 text-center">
                    <button disabled={loading} className="btn btn-sm btn-danger" onClick={() => reason?.removed ? handleRemove() : handleStatus(reason?.id, false)}>{loading ? <i className="fa-solid fa-spinner fa-spin"></i> : "Deactivate"}</button>
                </div>
            </Modal>
        </React.Fragment>
    )
}

export default List;